import { SWRResponse } from "swr";
import useQuery, {
  UseQueryOptions
} from "rivals/shared/hooks/useQuery/useQuery";
import { Response, UseGetCollegePlayerRequestParams } from "./types";

export default function useGetCollegePlayer(
  requestParams: UseGetCollegePlayerRequestParams,
  options?: UseQueryOptions
): SWRResponse<Response> {
  const url = `/api/v2/athletes/college_player?player[person_id]=${requestParams.personId}`;
  return useQuery<Response>(url, options);
}
